import { getToken } from "lib/api";

// In production everything is behind nginx (same host, /recording/ws routed to
// the recording service). In dev the recording service runs on its own port, so
// REACT_APP_RECORDING_WS_BASE (e.g. "ws://localhost:8002") overrides the host.
const WS_BASE = process.env.REACT_APP_RECORDING_WS_BASE || "";

// `agentBase` is the machine the SERVER assigned this session to (wss://ws1...).
// It wins over everything: the session's raw buckets live on that agent's disk, so
// there is exactly one right host and the client does not get a say. Empty (the
// all-in-one and single-machine case) falls back to the old behaviour — the dev
// override, then the origin the page loaded from.
export function buildWsUrl(wsPath, agentBase, tokenOverride) {
  let base = agentBase || WS_BASE;
  if (!base) {
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    base = `${proto}//${window.location.host}`;
  }
  // The external-camera phone page has no localStorage bearer; it passes the
  // scoped pairing token explicitly. Everyone else uses the logged-in token.
  const token = tokenOverride != null ? tokenOverride : getToken();
  const sep = wsPath.includes("?") ? "&" : "?";
  return `${base.replace(/\/$/, "")}${wsPath}${sep}token=${encodeURIComponent(token || "")}`;
}

// HTTP base for the recording service (HLS live feed / media). Same routing
// story as buildWsUrl: empty in prod (behind nginx), overridden in dev.
const HTTP_BASE = process.env.REACT_APP_RECORDING_HTTP_BASE || "";

// Same story, for the HTTP twin (the HLS fallback). `agentBase` here is an http(s)
// origin: a wss:// base is converted, since the server hands out one URL per agent
// and this is the same host by a different scheme.
export function buildRecordingUrl(path, agentBase) {
  let base = agentBase ? agentBase.replace(/^ws/, "http") : HTTP_BASE;
  if (!base) base = `${window.location.protocol}//${window.location.host}`;
  base = base.replace(/\/$/, "");
  const token = getToken();
  const sep = path.includes("?") ? "&" : "?";
  return `${base}${path}${sep}token=${encodeURIComponent(token || "")}`;
}
